const images = {
    logo: require('./logo.svg').default,
    noImage: require('./no-image.png'),
    imageNotFound: require('./imgNotFound.jpg'),
};

export default images;
